const React = require("react");
const T = require("prop-types");
const { Router: StrangeRouter } = require("strange-router");
const Provider = require("react-redux").Provider;
const MuiThemeProvider = require("material-ui/styles/MuiThemeProvider").default;
const getMuiTheme = require("material-ui/styles/getMuiTheme").default;
const MuiTheme = require("../styles/themeStyles");

const App = ({ store, routes, history }) => {
    return (
        <Provider store={store}>
            <MuiThemeProvider muiTheme={getMuiTheme(MuiTheme)}>
                <div style={{ height: "100%" }}>
                    <StrangeRouter history={history} routes={routes} />
                </div>
            </MuiThemeProvider>
        </Provider>
    );
};

App.propTypes = {
    history: T.object.isRequired,
    routes: T.array.isRequired,
    store: T.object.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js